import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import ProjectFaqWidget from './ProjectFaqWidget';
import { IInnerProject } from '../../types/inner_page';
import ProjectFilesWidget from './ProjectFilesWidget';
import i18n from '../../i18n';
import { useMsal } from '@azure/msal-react';
interface ProjectLibraryWidgetProps {
  pageItem: IInnerProject;
  
}




const CustomContactForm: React.FC<ProjectLibraryWidgetProps> = ({ pageItem }: { pageItem: IInnerProject }) => {
  const { instance } = useMsal();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(''); // Success message state

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!message.trim()) {
      setError(i18n.t('Message cannot be empty.'));
      return;
    }
    setError('');
    setSuccess('');

    try {
      const account = instance.getActiveAccount();
      if (!account) {
        console.error("No active account found. Please ensure the user is logged in.");
        return;
      }

      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: account,
      });
      const token = response.accessToken;

      const apiResponse = await fetch('https://reports-api.tatweertransit.com/Tawasol/eportal-projects', {
      //  const apiResponse = await fetch('http://localhost:8002/Tawasol/eportal-projects', {
          method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ message })
      });

      if (apiResponse.ok) {
        const data = await apiResponse.json();
        setSuccess(data.message || i18n.t('Contact saved successfully'));
        setMessage(''); // Reset the message input
      } else {
        setError(i18n.t('Failed to submit form'));
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError(i18n.t('An error occurred while submitting the form.'));
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="d-flex flex-column flex-grow-1 p-3">
      <Form.Group as={Row} controlId="formMessage" className="mb-3 flex-grow-1">
        <Form.Label column sm="3">{i18n.t('Message')}:</Form.Label>
        <Col sm="9">
          <Form.Control
            as="textarea"
            rows={7}
            placeholder={i18n.t('Type your message here')}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="flex-grow-1"
          />
        </Col>
      </Form.Group>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}
      
      {success && (
        <Alert variant="success" className="mb-3">
          {success}
        </Alert>
      )}

      <div className="d-flex justify-content-end">
        <Button variant="success" type="submit">
          {i18n.t('Send')}
        </Button>
      </div>
    </Form>
  );
};


const ProjectLibraryWidget: React.FC<ProjectLibraryWidgetProps> = ({ pageItem }: { pageItem: IInnerProject }) => {
  const { i18n } = useTranslation();


  return (

    <Row className="tarabut-journey-widget-row">

 

    <div className="tarabut-journey-widget-none">




    <Container fluid>
      <Row className="tarabut-journey-widget-rowx">
        <Col xs={12} md={4} className="d-flex">
          <Card className="custom-card flex-grow-1">
            <Card.Header className="custom-card-header">
              <div className="d-flex align-items-center w-100">
                <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                <span className='p-1'>{i18n.t('DOCUMENTS LIBRARY')}</span>
              </div>
            </Card.Header>
            <Card.Body className="p-0 custom-card-body">
            <ProjectFilesWidget language={i18n.language}  pageItem={pageItem} />

            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={4} className="d-flex">
          <Card className="custom-card flex-grow-1">
            <Card.Header className="custom-card-header">
              <div className="d-flex align-items-center w-100">
                <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                <span className='p-1'>{i18n.t('FAQ')}</span>
              </div>
            </Card.Header>
            <Card.Body className="p-0 custom-card-body">
              <ProjectFaqWidget language={i18n.language}  pageItem={pageItem} />
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={4} className="d-flex">
          <Card className="custom-card flex-grow-1">
            <Card.Header className="custom-card-header">
              <div className="d-flex align-items-center w-100">
                <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                <span className='p-1'>{i18n.t('Contact')}</span>
              </div>
            </Card.Header>
            <Card.Body className="p-3 d-flex flex-column custom-card-body">
              <CustomContactForm  pageItem={pageItem} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>


    </div>



     
</Row>

  );
};

export default ProjectLibraryWidget;
